$(document).ready(function() {
    $('.menu span').hover(function() {
        var t = $(this);
        var menu = t.children('.dropmenu');
        var height = menu.height();

        if(t.closest('.smenu').length == 0 && !menu.hasClass('no-shift')) {
            menu.css('left', -(t.offset().left - t.closest('ul').offset().left));
            menu.css('min-height', '0px');
        }

        menu.slideDown(200);

        menu.show();
    }, function() {
        $(this).children('.dropmenu').hide();
    });
});


function addToFavourites(p, callback) {
    $.ajax({
        type: 'GET',
        url: BASE_URL + '/account/favourites/add',
        data: {
            'p': p
        },
        dataType: 'json',
        success: function(msg) {
            if (msg.state){
                $('#productFav' + p).addClass("act").html('<span>удалить</span>');
                $('#favWidget').replaceWith(msg.widget);
                if (typeof(callback) == 'function')
                    callback();
            }
            else
                toggleError(msg.msg);
        }
    });
}

function removeFromFavourites(p, callback) {
    $.ajax({
        type: 'GET',
        url: BASE_URL + '/account/favourites/remove',
        data: {
            'p': p
        },
        dataType: 'json',
        success: function(msg) {
            if (msg.state){
                $('#productFav' + p).removeClass("act").html('<span>отложить</span>');
                $('#favWidget').replaceWith(msg.widget);
                if (typeof(callback) == 'function')
                    callback();
            }
            else
                toggleError(msg.msg);
        }
    });
}

function searchLoadingAnimation(start) {
    if (start === undefined)
        start = true;
    if (start) {
        $('#searchAnimationContainer').fadeIn(400);
    } else {
        $('#searchAnimationContainer').fadeOut(400);
    }
}

(function($) {
    var methods = {
        "val": function(val) {
            if (typeof(val) === "undefined")
                return this.find("h6").attr("data-id");
            this.change(val, true);
            return this;
        },
        "change": function(val, trigger) {
            var el = this.children("ul").find('a[data-id="' + val + '"]');
            var h6 = this.find("h6");
            var changed = (h6.attr("data-id") !== val);
            if (el.length) {
                el.parent().addClass("hiden").siblings().removeClass("hiden");
                h6.html(el.html());
                if (changed) {
                    h6.attr("data-id", val);
                    this.find('input[type="hidden"]').val(val);
                    if (trigger)
                        this.trigger("change");
                }
            }
            return this;
        }
    };
    
    $.fn.pseudosel = function(settings) {
        for (var i in methods)
            this[i] = methods[i];
        if (typeof(settings) === "undefined")
            return this;
        
        var obj = this;
        var opts = $.extend({
            "data": [],
            "active": "",
            "titleSpan": true
        }, settings);
        this.html('<h6></h6>'
            + '<ul></ul>');
        if (opts.data.length > 1) {
            this.children("h6").bind("click", function (e) {
                e.stopPropagation();
                $(this).next().toggle();
                $("html").bind("click.pseudosel", function() {
                    obj.children("ul").hide();
                    $(this).unbind("click.pseudosel");
                });
            });
        }
        var sel = this.children("ul");
        var t;
        for (var i in opts.data) {
            t = opts.data[i]["title"];
            if (opts.titleSpan)
                t = "<span>" + t + "</span><s></s>";
            sel.append('<li><a href="/salony/' + opts.data[i]["alias"] + '" onclick="return false" data-id="' + opts.data[i]["id"] + '">'
                + t + '</a></li>');
        }
        sel.find("a").each(function() {
            $(this).bind("click", function() {
                obj.change($(this).data("id"), true);
                sel.hide();
            });
        });
        if (typeof(opts.inputName) !== "undefined")
            this.prepend('<input type="hidden" name="' + opts.inputName + '"/>');
        this.change(opts.active, false);
        return this;
    };
})(jQuery);

// выключил Коваленко А.А., ломала страницу франшизы
// $(function() {
//     $('.menu.mmenu').find('a').each(function() {
//         if ($(this).attr('target') !== '_blank') {
//             $(this).bind('click', function(e) {
//                 if ((e.button == 0) && !e.altKey && !e.ctrlKey && !e.shiftKey) {
//                     if ($(this).parent().get(0).tagName.toLowerCase() != 'b') {
//                         var bel = $(this).closest('ul').find('>li>b');
//                         bel.replaceWith(bel.html());
//                         $(this).replaceWith('<b>' + $(this).html() + '</b>');
//                     }
//                 }
//             });
//         }        
//     });
//     $('.menu.smenu').find('a').each(function() {
//         if ($(this).attr('target') !== '_blank') {
//             $(this).bind('click', function(e) {
//                 if ((e.button == 0) && !e.altKey && !e.ctrlKey && !e.shiftKey) {
//                     if ($(this).parent().get(0).tagName.toLowerCase() != 'b') {
//                         var bel = $(this).closest('ul').find('>li>b');
//                         bel.replaceWith(bel.html());
//                         $(this).replaceWith('<b class="secondary-link-menu">' + $(this).html() + '</b>');
//                     }
//                 }
//             });
//         }        
//     });
// });

// Меню для мобильной версии

$(function() {
    var $accordeon = $('.js-accordeon');
    if (!$accordeon.length) return;

    var $btnAccordeon = $('.js-btn-accordeon');

    $btnAccordeon.click(function(e) {
        e.preventDefault();
        
        var $that = $(this),
            $dropmenu = $that.closest('li').find('ul');
            // lvl = $that.data('lvl'),
            // $ctxMenuBtn = $that.closest('ul').find('.js-btn-accordeon[data-lvl="' + lvl + '"]');


        if (!$that.closest('.accordeon-btn').hasClass('_active')) {
            $that.closest('.accordeon-btn').addClass('_active');
            //$dropmenu.removeClass('_active');
        } else {
            //$ctxMenuBtn.removeClass('_active');
            $that.closest('.accordeon-btn').removeClass('_active');
        }
    });
});

$(function() {
    var $btnMenu = $('.js-btn-menu'),
        $mobileMenu = $('.js-accordeon');

    // console.log($btnMenu, $mobileMenu.height());

    $btnMenu.click(function(e) {
        e.preventDefault();

        var $burger = $(this).find('.icon-burger');

        if(!$mobileMenu.hasClass('_active')) {
            $mobileMenu.addClass('_active');
            $burger.addClass('icon-burger--close');

        } else {
            $mobileMenu.removeClass('_active');
            $burger.removeClass('icon-burger--close');
        }
    });
});


// Аккордеон в футере

$(function() {
    var $accordeon = $('.js-accordeon-ftr');
    if (!$accordeon.length) return;

    var maxHeight = 0;

    $.each($accordeon, function (i, el) {
        var li = $(el).closest('.botset').find('li'),
            liHeight = li.outerHeight(true),
            liLn = li.length,
            totalHeight = liHeight * liLn;

        if(maxHeight <= totalHeight) {
            maxHeight = totalHeight;
        }
    })
    
    $accordeon.click(function (e) {
        var $that = $(this),
            $ul = $that.closest('.botset').find('ul');

        if(!$that.hasClass('_active')) {
            $that.addClass('_active');
            $ul.css('max-height', maxHeight);
        } else {
            $that.removeClass('_active');
            $ul.css('max-height', 0);
        }
    })
});


// Слайдер недавно просмотренных товаром в catalog.html

$(function() {
    var $slider = $('.js-slider-recent');
    if(!$slider.length) return;

    // console.log('check');

    initSliderRecent($slider);

    function initSliderRecent(slider) {
        slider.slick({
            slide: 'a',
            slidesToShow: 12,
            slidesToScroll: 12,
            infinite: false,
            variableWidth: true,
            arrows: true,
            appendArrows: '.slider-recent-arrows',
            prevArrow: '<span class="promo-slider__prev">' +
                            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="9" height="15" viewBox="0 0 9 15">' +
                                '<path d="M0.287,8.329 C2.606,10.461 4.925,12.594 7.245,14.725 C8.200,15.603 9.623,14.177 8.665,13.296 C6.600,11.399 4.536,9.502 2.472,7.604 C4.547,5.641 6.621,3.676 8.696,1.711 C9.641,0.817 8.217,-0.609 7.275,0.283 C4.945,2.489 2.616,4.694 0.287,6.900 C-0.099,7.266 -0.109,7.966 0.287,8.329 Z" id="path-1" class="cls-2" fill-rule="evenodd"/>' +
                            '</svg>' +
                        '</span>',
            nextArrow: '<span class="promo-slider__next">' +
                            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="9" height="15" viewBox="0 0 9 15">' +
                                '<path d="M8.713,6.671 C6.394,4.539 4.075,2.406 1.755,0.275 C0.800,-0.603 -0.623,0.823 0.335,1.704 C2.400,3.601 4.464,5.498 6.528,7.396 C4.453,9.359 2.379,11.324 0.304,13.289 C-0.641,14.183 0.783,15.609 1.725,14.717 C4.055,12.511 6.384,10.306 8.713,8.100 C9.099,7.734 9.109,7.034 8.713,6.671 Z" id="path-1" class="cls-2" fill-rule="evenodd"/>' +
                            '</svg>' +
                        '</span>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 9,
                        slidesToScroll: 3,
                        infinite: false,
                        variableWidth: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: false,
                        variableWidth: true
                    }
                }
            ]
        });
    }
})

// Раскрытие опций каталога на мобильных
$(function() {
        
    $(document).on('click', '.js-mobile-opt-btn', function() {
        var $that = $(this),
            $btn = $('.js-mobile-opt-btn'),
            $container = $('.js-mobile-opt-container'),
            data = $that.data('option'),
            $ctxContatiner = $('.js-mobile-opt-container[data-opt-container="'+data+'"]');

        if(!$that.hasClass('_active')) {
            $btn.removeClass('_active');
            $container.removeClass('_active');
            $that.addClass('_active');
            $ctxContatiner.addClass('_active');
        } else {
            $that.removeClass('_active');
            $ctxContatiner.removeClass('_active');
        }
    });

    $(document).on('click', '.js-roll-up-btn', function(e) {
        var $that = $(this),
            $ctxContatiner = $that.closest('.js-mobile-opt-container'),
            data = $ctxContatiner.data('opt-container'),
            $ctxMenuBtn = $('.js-mobile-opt-btn[data-option="'+data+'"]'),
            scrollTo = $('.mobile-catalog-options').offset().top;

        $ctxContatiner.removeClass('_active');
        $ctxMenuBtn.removeClass('_active');

        // $('html, body').animate({
        //     scrollTop: scrollTo
        // }, 500);
    });
});


$(function() {
    var slider = $('#otherPicsContainer');

    if($(window).width() < 1000) {
        if(!slider.hasClass('slick-slider')) {
            initSlider(slider);
        }
    } else {
        if(slider.hasClass('slick-slider')) {
            slider.slick('unslick');
        }
    }

    $(window).on('resize', function() {
        var w = $(window).width();
        // console.log(w);

        if(w < 1000) {
            if(!slider.hasClass('slick-slider')) {
                initSlider(slider);
            }
        } else {
            if(slider.hasClass('slick-slider')) {
                slider.slick('unslick');
            }
        }
    })

});

// Инициализация слайдера для карточки товара и попапа "Быстрый просмотр"
function initSlider(slider) {
    slider.slick({
        infinite: false,
        variableWidth: true,
        // slide: '.js-slider-item',
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<span class="promo-slider__prev">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="9" height="15" viewBox="0 0 9 15">' +
                            '<path d="M0.287,8.329 C2.606,10.461 4.925,12.594 7.245,14.725 C8.200,15.603 9.623,14.177 8.665,13.296 C6.600,11.399 4.536,9.502 2.472,7.604 C4.547,5.641 6.621,3.676 8.696,1.711 C9.641,0.817 8.217,-0.609 7.275,0.283 C4.945,2.489 2.616,4.694 0.287,6.900 C-0.099,7.266 -0.109,7.966 0.287,8.329 Z" id="path-1" class="cls-2" fill-rule="evenodd"/>' +
                        '</svg>' +
                    '</span>',
        nextArrow: '<span class="promo-slider__next">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="9" height="15" viewBox="0 0 9 15">' +
                            '<path d="M8.713,6.671 C6.394,4.539 4.075,2.406 1.755,0.275 C0.800,-0.603 -0.623,0.823 0.335,1.704 C2.400,3.601 4.464,5.498 6.528,7.396 C4.453,9.359 2.379,11.324 0.304,13.289 C-0.641,14.183 0.783,15.609 1.725,14.717 C4.055,12.511 6.384,10.306 8.713,8.100 C9.099,7.734 9.109,7.034 8.713,6.671 Z" id="path-1" class="cls-2" fill-rule="evenodd"/>' +
                        '</svg>' +
                    '</span>'
    });
}


// Таблица размеров для мобильных
$(function() {
    var $btn = $('.js-table-mob-btn');

    $(document).on('click', '.js-table-mob-btn', function() {
        var $that = $(this),
            $container = $that.closest('.js-table-sizes-mob');

        $container.toggleClass('_active', !$container.hasClass('_active'));
    });
});

// Попапы после добавления в корзину и система флекс (для демострации в верстке)

$(function() {
    var $ajaxPopupBtn = $('.js-ajax-popup');

    $ajaxPopupBtn.on('click', function(event) {
        event.preventDefault();

        var url = $(this).data('url');

        ajaxPopup(url);
    });

    function ajaxPopup(url) {
        $.ajax(url, {
            type: 'GET',
            dataType: 'html',
            timeout: 3000,
            success: function(result) {
                var $result = $(result),
                    $toRemove = $('#dmw').find('#dmwbg').next();;

                $result.css({
                    'display': 'block',
                    'left': '50%',
                    'top': '50%',
                    '-webkit-transform': 'translate(-50%, -20%)',
                    '-ms-transform': 'translate(-50%, -20%)',
                    '-o-transform': 'translate(-50%, -20%)',
                    'transform': 'translate(-50%, -20%)'
                });
                 
                if($toRemove.length) $toRemove.remove();

                $('#dmw').css({
                    'display': 'block'
                });

                $('#dmwbg').css({
                    'width': '100%',
                    'height': '100%'
                });

                $('#dmw').append($result);
            }
        });
    }
});

// Input number

(function() {
 
  window.inputNumber = function(el) {

    var min = el.attr('min') || false;
    var max = el.attr('max') || false;

    var els = {};

    els.dec = el.prev();
    els.inc = el.next();

    el.each(function() {
      init($(this));
    });

    function init(el) {

      els.dec.on('click', decrement);
      els.inc.on('click', increment);

      function decrement() {
        var value = el[0].value;
        value--;
        if(!min || value >= min) {
          el[0].value = value;
        }
      }

      function increment() {
        var value = el[0].value;
        value++;
        if(!max || value <= max) {
          el[0].value = value++;
        }
      }
    }
  }
})();

$(function() {
    $('.input-number').each(function(i, el) {
        inputNumber($(el));
    });
});

// $(function() {
//     var inputNumber = $('.input-number');

//     inputNumber.on('keypress', function(event) {
//         return event.charCode >= 48 && event.charCode <= 57;
//     });
// });

$(function() {
    var $sizeSelect = $('.js-size-select');
    if(!$sizeSelect.length) return;

    nSelectInit($sizeSelect);
});

function nSelectInit(target) {
    target.nSelect({
        hideAfterSelect: true,
        afterChange: function(el) {
            var $ctx = el.closest('.product-main'),
                $ctxProduct = el.closest('.basket-product'),
                $selects = $ctx.find('.nselect'),
                $sizes = $selects.find('.nselect__list li');
            
            var deleted = $ctxProduct.hasClass('_no-size');
            
            if($ctxProduct.hasClass('_no-size')) {
                var valueToDelete = $ctx.find('.nselect__head').data('val'),
                    itemToDelete = $selects.find('.nselect__list li[data-val="'+valueToDelete+'"]'),
                    pickSizeToDelete = $('.product-option-size[data-pick="'+valueToDelete+'"]');

                itemToDelete.remove();
                pickSizeToDelete.remove();
                console.log(valueToDelete);
                $ctxProduct.removeClass('_no-size');
                el.remove();
            }

            if($selects.length > 1) {
                var pikedSizes = [];

                $selects.each(function(i, el) {
                    pikedSizes[i] = $(el).find('.nselect__head').attr('title');
                });

                // console.log($sizes);

                $sizes.removeClass('_hidden');

                if(pikedSizes.length > 0) {
                    pikedSizes.forEach(function(elem) {
                        var $target = $selects.find('.nselect__list li[data-val="'+elem+'"]');

                        $target.each(function(i, el) {
                            if(!$(el).hasClass('_hide')) {
                                $(el).addClass('_hidden');
                            }
                        });
                    });
                }

                // console.log(el.data('val'), $selects, pikedSizes);
            }
            
            var select = el.closest('.nselect').find('select');
            var val = el.find('span').text().replace(' ', '');
            
            select.find("option").filter(function() {
                var t = $(this);
                t.removeAttr('selected');
                return t.text() == val; 
            }).attr('selected', 'selected');
            
            if(deleted) {
                $ctxProduct.find('.input-number').val(1);
                cartDispatcher.editItem($ctxProduct.attr('id'));
            } else {
                select.trigger('change');
            }
        },
        afterOpen: function(el) {
            $('.nselect').removeClass('_active');
            var $productAdd = $('.js-product-add._active');

            if($productAdd) $productAdd.click();
            
            el.closest('.nselect').addClass('_active');
        }
    });
}

$(function() {
    var $products = $('.product-main');
    if(!$products.length) return;

    $(window).load(function() {
        
        $products.each(function (i, el) {
            var pikedSizes = [],
                $select = $(el).find('.nselect'),
                $sizes = $(el).find('.nselect__list li');

            if($select.length > 1) {
                $select.each(function(i, el) {
                    pikedSizes[i] = $(el).find('.nselect__head').attr('title');
                });
            }

            if(pikedSizes.length > 0) {
                pikedSizes.forEach(function(elem) {
                    var $target = $(el).find('.nselect__list li[data-val="'+elem+'"]');

                    $target.each(function(i, el) {
                        if(!$(el).hasClass('_hide')) {
                            $(el).addClass('_hidden');
                        }
                    });
                });
            }
        });
    });
});

// Добавить размер (цвет) в корзине

$(function() {
    var $basket = $('.basketwrap'),
        $productOptionsPick = $('.js-product-option-pick'),
        $productAddForm = $('.product-pick-form');

    $basket.on('click', '.js-product-option-pick', function(e) {
        var $that = $(this),
            $ctx = $that.closest('.product-pick-options'),
            $submitBtn = $ctx.find('.js-choose-prod-option'),
            pick = $that.data('pick');

        if($that.hasClass('_active')) return;

        $productOptionsPick.removeClass('_active');
        $that.addClass('_active');

        if($that.hasClass('product-option-color')) {
            $ctx.find('.js-picked-color').val($that.data('pick'));
            $ctx.find('.js-picked-hex').val($that.data('color'));
        } else {
            $ctx.find('.js-picked-size').val($that.data('pick'));
        }

        $submitBtn.removeClass('_disabled').attr('disabled', false);
    });

    $basket.on('submit', '.product-pick-form', function(e) {
        e.preventDefault();

        var $that = $(this),
            $ctxSize = $that.closest('.product-options'),
            $ctxProduct = $that.closest('.basket-product'),
            $productMain = $that.closest('.product-main'),
            $closeBtn = $that.closest('.product-pick-options').find('.js-product-add-close'),
            $productPrice = $ctxProduct.find('.unit-price-wr'),
            $amountProductPrice = $ctxProduct.find('.js-unit-amount-price'),
            $productName = $ctxProduct.find('.product-link a span'),
            productPrice = $ctxProduct.find('.js-unit-price')[0].innerHTML,
            msg = $that.serialize(),
            msaArr = $that.serializeArray(),
            dataObj = {},
            type = $that.data('type'),
            url = $that.data('url');

        msaArr.forEach(function(el) {
            dataObj[el.name] = el.value;
        });

        console.log(dataObj, $productName, productPrice);
        
        if(type == 'size') {
            $.get('/account/cart/add', {productID : $that.data('product'), propertyID : $that.find('.js-picked-size').val()}, function() {
                window.cartDispatcher.editItem($('.basket-product').eq(0).attr('id'));
            });
        } else if(type == 'color') {
            $.get('/account/cart/add', {productID : $that.find('input[name="prod_picked_color"]').val(), propertyID : $that.find('input[name="prod_picked_color_hex"]').val()}, function() {
                window.cartDispatcher.editItem($('.basket-product').eq(0).attr('id'));
            });
        }
//        $.ajax({
//            type: 'GET',
//            url: url,
//            data: msg,
//            success: function(response) {
//                var $response = $(response),
//                    productPrice = $ctxProduct.find('.js-unit-price')[0].innerHTML,
//                    returnHtml;
//                    
//                if(type == 'size') {
//                    returnHtml = $response.find('.product-unit');
//
//                    var $select = returnHtml.find('.js-size-select'),
//                        $option = $select.find('option[value="'+dataObj.prod_picked_size+'"]'),
//                        $color = returnHtml.find('.unit-color'),
//                        $size = returnHtml.find('.unit-size'),
//                        $numbers = returnHtml.find('.input-number'),
//                        $unitPrice = returnHtml.find('.unit-price-wr'),
//                        $amountPrice = returnHtml.find('.unit-amount-price'),
//                        amountPrice = 0;
//
//                    $color.empty();
//                    $unitPrice.html($productPrice.html());
//                    $amountPrice.removeClass('js-unit-amount-price').empty();
//
//                    inputNumber($numbers);
//
//                    $size.append('<button class="basket-product-delete js-remove-size-basket"></button>')
//
//                    $option.attr('selected', true);
//                    nSelectInit($select);
//
//                    $ctxSize.before(returnHtml);
//
//                    $allNumbers = $ctxProduct.find('.input-number');
//
//                    amountPrice = calculatePrice($allNumbers, productPrice);
//                    $amountProductPrice.html(amountPrice + ',00 р.');
//
//                    syncSizeSelectors($productMain);
//                } else {
//                    returnHtml = $response;
//
//                    var $select = returnHtml.find('.js-size-select'),
//                        $color = returnHtml.find('.js-unit-color-name'),
//                        $numbers = returnHtml.find('.input-number'),
//                        $unitPrice = returnHtml.find('.unit-price-wr'),
//                        $amountPrice = returnHtml.find('.js-unit-amount-price'),
//                        $prodName = returnHtml.find('.product-link a span'),
//                        amountPrice = 0;
//
//                    $color.html('<i class="product-color-icon"'+ 
//                        'style="background-color:'+dataObj.prod_picked_color_hex+';"></i>'+
//                        dataObj.prod_picked_color+'</span>');
//
//                    $unitPrice.html($productPrice.html());
//                    $prodName.text($productName.text());
//
//                    inputNumber($numbers);
//
//                    nSelectInit($select);
//
//                    amountPrice = calculatePrice($numbers, productPrice);
//                    $amountPrice.html(amountPrice + ',00 р.');
//
//                    $ctxProduct.after(returnHtml);
//                }
//            },
//            error:  function(xhr, str){
//                alert('Возникла ошибка: ' + xhr.responseCode);
//            }
//        });
        
        $closeBtn.click();
    });
});

function syncSizeSelectors(target) {
    var pikedSizes = [],
        $select = target.find('.nselect'),
        $sizes = target.find('.nselect__list li');

    if($select.length > 0) {
        $select.each(function(i, el) {
            pikedSizes[i] = $(el).find('.nselect__head').attr('title');
        });
    }

    console.log(pikedSizes);

    if(pikedSizes.length > 0) {
        pikedSizes.forEach(function(elem) {
            var $target = target.find('.nselect__list li[data-val="'+elem+'"]');

            $target.each(function(i, el) {
                if(!$(el).hasClass('_hide')) {
                    $(el).addClass('_hidden');
                }
            });
        });
    }
}
// Открыть/Закрыть попап "Добавить размер/цвет"

$(function() {
    var $basket = $('.basketwrap'),
        $productAdd = $('.js-product-add'),
        $productAddClose = $('.js-product-add-close');

    $basket.on('click', '.js-product-add', function(e) {
        var $that = $(this),
            $ctx = $that.closest('.product-options'),
            $ctxProduct = $ctx.closest('.product-main'),
            $currSizes = $ctxProduct.find('.nselect__head'),
            data = $that.data('add'),
            $submitBtn = $ctx.find('.js-choose-prod-option'),
            $allOptions = $('.product-pick-options'),
            $allSizes = $('.js-product-option-pick'),
            $ctxOption = $ctx.find('.product-pick-options[data-option="'+data+'"]');

        // console.log($ctx, $ctxOption, $currSizes);

        $allSizes.removeClass('_active _hidden');
        $submitBtn.addClass('_disabled').attr('disabled', true);

        $currSizes.each(function(i, el){
            var data = $(el).attr('title'),
                $target = $('.js-product-option-pick[data-pick="'+data+'"]');
        
            $target.addClass('_hidden');
        });

        if($that.hasClass('_active')) {
            $that.removeClass('_active');
            $ctxOption.removeClass('_active');
        } else {
            $productAdd.removeClass('_active');
            $that.addClass('_active');
            $allOptions.removeClass('_active');
            $ctxOption.addClass('_active');
        }
    });

    $basket.on('click', '.js-product-add-close', function(e) {
        e.preventDefault();

        var $that = $(this),
            data = $that.closest('.product-pick-options').data('option'),
            $ctxTab = $that.closest('.product-options').find('.js-product-add[data-add="'+data+'"]');

        $ctxTab.click();
    });
});

// Удаление товара из корзины
$(function() {
    var $basket = $('.basketwrap');

    $basket.on('click', '.js-remove-from-basket', function(e) {
        var $that = $(this),
            $product = $that.closest('.basket-product');

        $product.remove();
    });

    $basket.on('click', '.js-remove-size-basket', function(e) {
        var $that = $(this),
            $ctx = $that.closest('.basket-product'),
            $size = $that.closest('.product-unit');
        
        $size.remove();

        console.log($ctx);

        var $allInputs = $ctx.find('.input-number'),
            $productMain = $that.closest('.product-main'),
            $sizes = $ctx.find('.nselect__list li'),
            $amountPrice = $ctx.find('.js-unit-amount-price'),
            productPrice = $ctx.find('.js-unit-price')[0].innerHTML;


        $sizes.removeClass('_hidden');
        syncSizeSelectors($productMain);

        var resetPrice = calculatePrice($allInputs, productPrice);

        for(var i = resetPrice.length; i > 0; i--) {
            console.log(resetPrice[i]);
        }

        $amountPrice.html(resetPrice + ',00 р.');

    });

    // Проверка колличества при загрузке
    var $unitQuantity = $('.unit-quantity');

    checkMinMax($unitQuantity);

    // Изменение кол-ва товара
    $basket.on('click', '.input-number-decrement, .input-number-increment', function() {
        var $that = $(this),
            $ctx = $that.closest('.basket-product'),
            $allInputs = $ctx.find('.input-number'),
            $qnt = $ctx.find('.unit-quantity'),
            $amountPrice = $ctx.find('.js-unit-amount-price'),
            url = $ctx.data('url'),
            productPrice = $ctx.find('.js-unit-price')[0].innerHTML,
            productCount = 0;

        checkMinMax($qnt);

        var product = {
            "id": $ctx.attr('id'),
            "count": productCount
        };

        amountPrice = calculatePrice($allInputs, productPrice);
        $allInputs.trigger('change');
        $amountPrice.html(amountPrice + ',00 р.');

    });

    checkMinMax($('.unit-quantity'));
    
    // Проверка колличества товара
    function checkMinMax(obj) {
        if(!obj.length) return false;

        obj.each(function(i, el) {
            var $minus = $(el).find('.input-number-decrement'),
                $plus = $(el).find('.input-number-increment'),
                min = $(el).find('input').attr('min'),
                max = $(el).find('input').attr('max'),
                val = $(el).find('input').val();

            if(val == min) {
                $minus.addClass('_hidden');
            } else {
                $minus.removeClass('_hidden');
            }

            if(val == max) {
                $plus.addClass('_hidden');
            } else {
                $plus.removeClass('_hidden');
            }
        });
    }
});


(function() {
 
    window.checkMinMax = function(obj) {
        if(!obj.length) return false;

        obj.each(function(i, el) {
            var $minus = $(el).find('.input-number-decrement'),
                $plus = $(el).find('.input-number-increment'),
                min = $(el).find('input').attr('min'),
                max = $(el).find('input').attr('max'),
                val = $(el).find('input').val();

            if(val == min) {
                $minus.addClass('_hidden');
            } else {
                $minus.removeClass('_hidden');
            }

            if(val == max) {
                $plus.addClass('_hidden');
            } else {
                $plus.removeClass('_hidden');
            }
        });
    }
})();

// Вычисляет сумму товаров в корзине
function calculatePrice(target, price) {
    var count = 0,
        priceNum,
        result;
    target.each(function(i, el) {
        count += +$(el).val();
    });

    // console.log(target, price);

    priceNum = price.replace(/,00 р.|\s/gi, '');

    result = count * +priceNum;
    return result;
}

$(function () {
    var $basketDiscount = $('.js-basket-discount');

    var delay = (function(){
        var timer = 0;
        return function(callback, ms){
            clearTimeout (timer);
            timer = setTimeout(callback, ms);
        };
    })();

    var requestSearchData = function(url, value, ctx) {
        var data,
            $ctxSearchResults = ctx.closest('.js-search-ctx').find('.js-search-results');
            searchResult = [];

        $.ajax(url, {
            type: 'GET',
            dataType: 'json',
            timeout: 3000,
            success: function(result) {
                data = result.items;
                var arr = [];

                data.forEach(function(el, i) {
                    var str = el.id;
                    arr[i] = str;
                });

                var check = arr.some(function(el) {
                    return el === value;
                })

                if(value.length === 0) {
                    ctx.removeClass('_invalid _valid');
                } else if(check) {
                    console.log('Check inputs true');
                    ctx.removeClass('_invalid');
                    ctx.addClass('_valid');
                } else {
                    console.log('Check inputs false');
                    ctx.removeClass('_valid');
                    ctx.addClass('_invalid');
                }

                console.log(arr, check);
            },
            error: function(request, errorType, errorMessage) {
                alert('Error: ' + errorType + ' with message: ' + errorMessage);
            },
            beforeSend: function() {
                
            },
            complete: function() {
                
            }
        });
    };
//    $basketDiscount.on('keyup', function(e) {
//        if(e.which != 13) {
//            return;
//        }
//        var $that = $(this);
//        var data = {};
//        
//        data[$that.attr('name')] = $that.val();
//        
//        $.post($that.data('url'), data, function() {
//            window.cartDispatcher.editItem($('.basket-product').eq(0).attr('id'));
//        });
//    });
    $basketDiscount.on('keyup', function() {
        var $that = $(this);
        
        if($that.val().length == 0) {
//            $that.removeClass('_invalid _valid');
//            return;
        }
        
        if($that.attr('id') == 'promoInput') {
            $.post($that.data('url'), {code : $that.val()}, function(data) {
                $that.removeClass('_invalid _valid');
                
                if(data.state == 0 && data.msg != 'Вы уже получали бонус') {
                    $that.addClass('_invalid');
                    $that.before(data.msg+'<br/>');
                } else {
                    if($that.val().length > 0) {
                        $that.addClass('_valid');
                    }
                    
                    if(typeof data.clear != 'undefined' && data.clear == 1) {
                        var el = $('#discountCard');
                        el.val('');
                        el.removeClass('_invalid _valid');
                    }
                    
                    window.cartDispatcher.editItem($('.basket-product').eq(0).attr('id'));
                }
            }, 'json');
            return;
        }
        
        $.post($that.data('url'), {discount : $that.val()}, function(data) {
            $that.removeClass('_invalid _valid');
            
            if(data.result == 'success') {
                if($that.val().length > 0) {
                    $that.addClass('_valid');
                }
                
                if(typeof data.clear != 'undefined' && data.clear == 1) {
                    var el = $('#promoInput');
                    el.val('');
                    el.removeClass('_invalid _valid');
                }
                
                window.cartDispatcher.editItem($('.basket-product').eq(0).attr('id'));
            } else {
                $that.addClass('_invalid');
            }
        }, 'json');

    });
});

// Валидация формы в корзине
function readyFormOrdering() {
    var $basketForm = $('#address-form');
    if (!$basketForm.length) return;

    jQuery.extend(jQuery.validator.messages, {
        required: "Поле не заполнено"
    });

//    $("input[name='CustomerAddress[phone]']").mask("+7 (999) 999-99-99");

    // метод проверки на текст
    $.validator.addMethod(
        'textonly',
        function(value, element) {
            valid = false;
            check = /[^-\a-zA-Zа-яА-ЯЁё\s]/.test(value);
            if (check == false)
                valid = true;
            return this.optional(element) || valid;
        },
        $.validator.format('Используете только буквы, пробелы или дефисы')
    );

    // метод проверки на телефон  
    $.validator.addMethod(
        'phone',
        function(value, element) {
            var re = /^[\+]?([0-9\(\)\s\-]{7,})$/im;
            return this.optional(element) || re.test(value);
        },
        'Неверно указан телефон'
    );

    // метод проверки на почту
    $.validator.addMethod(
        'email',
        function(value, element) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return this.optional(element) || re.test(value);
        },
        'Неверно указан Email'
    );

    var validator = $basketForm.validate({
        ignore: "",
        errorElement: "div",
        errorPlacement: function(error, element) {
            if (element.attr("name") == "pickupPlace") {
                element = $('input[name="'+$(element).attr('name')+'"]').filter(':checked')[0];
                error.insertAfter(element);
            } else {
                error.insertAfter(element);
            }
        },
        rules: {
            confirm: {
                required: true
            }
        },
        messages: {
            confirm: {
                required: 'Ознакомьтесь с правилами'
            }
        },
        submitHandler: function(form, event) {
            event.preventDefault();
                
            confirmOrder();
            return false;
        }
    });
    
    $.validator.addMethod(
        'custom',
        function(value, element) {
            var t = $(element);
            
            return this.optional(element) || t.closest('.ordering-input-wr').find('.error-dadata').length == 0;
        },
        ''
    );

    $.validator.addMethod(
        'pickup',
        function(value, element) {
            var radio = $('input[name="'+$(element).attr('name')+'"]').filter(':checked')[0];

            $('#' + $(radio).attr('name') + '-error').insertAfter(radio);
            return this.optional(element) || $(radio).val() != '';
        },
        'Не выбран пункт выдачи'
    );

    $("#ordering-address").each(function () {
        $(this).rules("add", {
            required: true,
            custom : true
        });
    });
    $("#ordering-name").each(function () {
        $(this).rules("add", {
            required: true,
            custom : true
        });
    });
//    $("#CustomerAddress_lastName").rules("add", {
//        textonly: true,
//        required: true
//    });
    $("#CustomerAddress_firstName").each(function () {
        $(this).rules("add", {
            textonly: true,
            required: true
        });
    });
    $("#CustomerAddress_street").each(function () {
        $(this).rules("add", {
            required: true
        });
    });
    $("#CustomerAddress_house").each(function () {
        $(this).rules("add", {
            required: true
        });
    });
    $("#check-rules").each(function () {
        $(this).rules("add", {
            required: true
        });
    });
    $("#CustomerAddress_email").each(function () {
        $(this).rules("add", {
            email: true,
            required: true
        });
    });
    $("#CustomerAddress_phone").each(function () {
        $(this).rules("add", {
            phone: true,
            required: true
        });
    });
    $('.js-delivery-pickup-input').each(function () {
        pickupRule(this);
    });
}

// Валидация радио пунктов выдачи
function pickupRule(input) {
    $(input).rules("add", {
        pickup: true,
        required: true
    });
}

// Фиксация мобильного меню при скролле
$(function() {
    var $mobileMenu = $('.menu-mobile-wr');
    if(!$mobileMenu.length) return;

    $(window).ready(function() {
        var trigger = $mobileMenu.offset().top,
            $basketContainer = $('.bigpage-basket');
            
        $(window).on('scroll touchmove touchstart touchend', function() {
            if(window.innerWidth < 768) {
                if(window.pageYOffset >= trigger) {
                    $mobileMenu.addClass('_fixed');
                    $basketContainer.addClass('_margin-top');
                } else {
                    $mobileMenu.removeClass('_fixed');
                    $basketContainer.removeClass('_margin-top');
                }
            }
        });

        $(window).on('resize', function() {
            if (window.innerWidth < 768 && window.pageYOffset > 280 && !$mobileMenu.hasClass('_fixed')) {
                $(window).scroll();
            } else if(window.innerWidth > 768 && window.pageYOffset < 280 && $mobileMenu.hasClass('_fixed')) {
               $(window).scroll();
            }
        });

        $(window).scroll();
    });
});

// список салонов города при ресайзе
$(function() {
    var $salonList = $('.salonlist'),
        $storePage = $('.content-store');

    if(!$salonList.length) return;

    var $sList = $('.js-map-mobile-tab[data-tab="salon-list"]');

    $(window).on('load resize', function(e) {
        if($(window).width() < 768) {
            if($salonList.hasClass('mCustomScrollbar')) {
                $salonList.mCustomScrollbar('destroy');
            }

            if(!$sList.hasClass('_active')) {
                if($storePage.length) return;
                $salonList.addClass('_hidden');
            }

            var $actCity = $('.content-store .salonlist li.act'),
                $map = $('.salonmap');

            if($actCity.length) {
                $actCity.after($map.addClass('_replaced'));
            }

            //$salonList.addClass('_hidden');
        } else {
            if(!$salonList.hasClass('mCustomScrollbar')) {
                $salonList.mCustomScrollbar('destroy');
            }

            if(!$salonList.hasClass('mCustomScrollbar')) {
                $salonList.mCustomScrollbar();
            }

            var $salonL = $('.salonlist-single'),
                $map = $('.salonmap');

            $salonL.after($map);

            $salonList.removeClass('_hidden');
        }
    });

    // if($(window).width() < 768) {
    //     $(window).on('load resize', function() {
    //         // if(!$sList.hasClass('_active')) {
    //         //     $salonList.addClass('_hidden');
    //         // }


    //     });

    //     // $salonList.addClass('_hidden');

    // } else {
    //     $(window).on('load resize', function() {
    //         $salonList.removeClass('_hidden');
    //     });

    //     $salonList.removeClass('_hidden');
    // }
});


// Salon mobile tabulation
$(function() {
    var $salonMobileTab = $('.js-map-mobile-tab');
    if(!$salonMobileTab.length) return;

    $salonMobileTab.on('click',function() {
        var $that = $(this),
            data = $that.data('tab'),
            $allTabs = $('.js-mobile-tab-ctx'),
            $tabCtx = $('.js-mobile-tab-ctx[data-tab-ctx="'+data+'"]');

        if(!$that.hasClass('_active')) {
            $salonMobileTab.removeClass('_active');
            $allTabs.addClass('_hidden');

            $tabCtx.removeClass('_hidden');
            $that.addClass('_active');
        }
    });
});

        


$(function() {
    var $scrollTo = $('.js-scroll-to');
    if(!$scrollTo.length) return;

    $scrollTo.on('click', function (e) {
        e.preventDefault();
        
        var $that = $(this),
            data = $that.data('scroll'),
            scrollTo = $('.js-scroll-target[data-scroll-target="'+data+'"').offset().top,
            fixpanelHeight = $('.fixpanel').height(),
            menuWrapHeight = $('.menu-wrap').outerHeight(true),
            menuMobileHeight = $('.menu-mobile').height(),
            correction = 0;

        if($(window).width() < 768) {
            correction = menuMobileHeight;
        } else {
            correction = fixpanelHeight + menuWrapHeight;
        }
    
        console.log(correction);

        $('html, body').animate({
            scrollTop: scrollTo - correction
        }, 500);
    });
});

// $(function() {
    
// });
